import React from 'react';

import { QText } from '../../../QAtoms';
import { CellRenderProps } from '../CellRenderProps';

export const TextCell: React.VFC<CellRenderProps<unknown>> = ({ value }) => (
  <QText>{value}</QText>
);
